<template>
  <div class="form-box">
    <p class="scoped-tips">*最多可选3个擅长领域</p>
    <el-form ref="scopedForm" :model="scopedForm" :rules="rules" v-if="ifForm==1">
      <el-form-item prop="checkItem">
        <div class="scoped-list">
          <el-checkbox-group v-model="scopedForm.checkItem" :min="0" :max="3">
            <el-checkbox v-for="item in itemData" :label="item.dataValue" :key="item.id" class="scoped-item">
              {{item.dataValue}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import fieidC from "@/common/edit/fieid";

export default {
  name: "editField",
  props: ["ifForm", "isCall", "params"],
  data () {
    return {
      rules: {
        // checkItem: [{ required: true, message: '*请选择领域', trigger: 'blur' }],
      },
      scopedForm: {
        checkItem: []
      },
      itemData: [],
      deleteDomainList: [],
      hospitalFlag: true,//
    };
  },
  components: {},
  watch: {
    isCall () {
      this.resetForm();
    }
  },
  created () {
    if (this.itemData.length == 0) {
      this.getData();
    }
    if (this.params) {
      this.scopedForm.checkItem = this.params.list || [];
      this.deleteDomainList = this.params.list || [];
    }
    // if (process.env.VUE_APP_NAME == "hospital") {
    //   this.hospitalFlag = false
    // } else {
    //   this.hospitalFlag = true
    // }
  },
  methods: {
    resetForm () {
      // 清空
      if (this.$refs.scopedForm) {
        this.$refs.scopedForm.resetFields();
      }
    },
    getData () {
      var params = {
        dataType: "domain"
      };
      this.catReq1Service("/api/v1/common/queryOptionList", params)
        .then(response => {
          if (response && response.resultCode === "1") {
            var result = response.result;
            if (result) {
              this.itemData = result;
              fieidC.init(this.itemData);
            }
            // //
          }
        })
      // .catch(error => {
      //   this.$message({
      //     message: "网络出错!",
      //     type: "error"
      //   });
      //   console.log(error);
      // });
    },
    submit (callback) {
      // 提交
      var that = this;
      this.$refs.scopedForm.validate(valid => {
        if (valid) {
          let ary = [];
          for (let i = 0; i < that.deleteDomainList.length; i++) {
            that.itemData.forEach(item => {
              if (item.dataDesc === that.deleteDomainList[i]) {
                ary.push({
                  domainName: item.dataDesc,
                  domainCode: item.dataKey
                });
              }
            });
          }

          var userDomainList = fieidC.toDataAry(this.scopedForm.checkItem);
          fieidC.submit(
            {
              // nickName: this.params.name,
              deleteDomainList: ary,
              addDomainList: userDomainList
            },
            () => {
              // //
              callback &&
                callback({
                  list: userDomainList
                });
            }
          );
        } else {
          return false;
        }
      });
    },
    // submit(callback){// 提交
    //   this.$refs.scopedForm.validate((valid) => {
    //     if (valid) {
    //       var params = {
    //         // item: this.toIdAry(this.scopedForm.checkItem),
    //         // itemName: this.scopedForm.checkItem,
    //         nickName:this.params.name,
    //         userDomainList: this.toDataAry(this.scopedForm.checkItem),
    //       };
    //       axios.post("/api/v1/user/update", params).then((response) => {

    //           console.log(response.data, "line: 51");
    //           callback&&callback({
    //             itemId: this.toIdAry(this.scopedForm.checkItem),
    //             itemName: this.scopedForm.checkItem,
    //             userLangList: this.toDataAry(this.scopedForm.checkItem),
    //           });

    //         }).catch((error) => {

    //           this.$message({
    //             message: "网络出错!",
    //             type: "error"
    //           });
    //           console.log(error);

    //         });
    //     } else {
    //       console.log('error submit!!');
    //       return false;
    //     }
    //   });
    // },

    onSubmit () {
    }
  }
};
</script>

<style lang="less" scoped>
.form-box {
  margin: 0 auto;
  width: 630px;
  text-align: left;
  position: relative;
  padding: 0 50px;
}
.scoped-list,
.scoped-tips {
  padding-left: 40px;
}
.scoped-item {
  margin: 0;
  width: 115px;
}
.scoped-tips {
  position: absolute;
  top: -20px;
  left: 0;
  padding-top: 6px;
  font-size: 12px;
  line-height: 12px;
  color: #999999;
}
</style>